import { render } from "./AboutMeComponent.vue?vue&type=template&id=f2d1900e&ts=true"
import script from "./AboutMeComponent.vue?vue&type=script&lang=ts"
export * from "./AboutMeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__